module.exports = __webpack_public_path__ + "static/assets/8ef878e12d441cb3d69c25dc17bc69d7.png";